<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Library/ Add</h1>
        </div>
        <div class="content-section">
            <div class="order-view max-WT setting-page">
                <div class="mb40">
                    <div class="add-store-block input-style mb20 ">
                        <form [formGroup]="form">
                            <div class="form-group row align-items-baseline">
                                <div class="col-md-12">
                                    <label class="mt20 my-4">Doc Name: </label>
                                    <input type="text" placeholder="Type doc name" class="form-control"
                                        formControlName="docName" maxlength="200"
                                        (keypress)="mainService.preventSpace($event)">
                                    @if(form.get('docName')?.hasError('required') && form.get('docName')?.dirty){
                                    <span class="text-danger">
                                        <small class="text-danger">*Doc Name is required.</small>
                                    </span>
                                    }
                                </div>
                            </div>
                            <div class="form-group row align-items-baseline">
                                <div class="col-md-12">
                                    <label class="mt20 my-4">Upload File:</label>
                                    <div class="input-group mb-3">
                                        <div class="custom-file">
                                            <input type="file" accept=".pdf , .docx , .doc , .mp3 , .mp4  ,.mov"
                                                (change)="ValidateFileUpload($event)" class="custom-file-input"
                                                id="inputGroupFile02">
                                            <label class="custom-file-label" for="inputGroupFile02">{{myFile || 'Choose
                                                file'}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="text-center mt40 mb40">
                        <button class="btn btn-large  max-WT-150 btn-theme" (click)="addLibraryApi()">Add</button>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>